<template>
  <div class="icon-nav-container">
    <button
      v-show="showLeftArrow"
      class="icon-nav-arrow"
      type="button"
      aria-label="Scroll left"
      @click="scrollNavigation('left')"
    >
      &lt;
    </button>
    <nav ref="navigationSlider" class="icon-nav no-scrollbar">
      <div class="label">
        <div
          id="BtnOverview"
          @click="configure('overview')"
          :class="{
            on:
              (showOverview === true && !itemDetailsActive) ||
              (currentVarType === '' &&
                showNameAndSize !== true &&
                showWarehouse !== true &&
                !itemDetailsActive),
          }"
        >
          <span>
            {{ $t("Common.all") }}
          </span>
        </div>
        <template v-if="getItemType === 'engagement'">
          <div
            v-if="menuList.colors"
            @click="configure('colors')"
            :class="{ on: currentVarType === 'colors' && !itemDetailsActive }"
          >
            <span>
              <i class="step">{{ getStepAsNumber("colors") }}.</i>
              {{ $t("Set.Item.Description.color") }}
            </span>
          </div>
          <div
            v-if="menuList.metals"
            @click="configure('metals')"
            :class="{ on: currentVarType === 'metals' && !itemDetailsActive }"
          >
            <span>
              <i class="step">{{ getStepAsNumber("metals") }}.</i>
              {{ $t("Set.Item.Description.alloy") }}
            </span>
          </div>
          <div
            v-if="menuList['jewellery/model']"
            @click="configure('jewellery/model')"
            :class="{
              on: currentVarType === 'jewellery/model' && !itemDetailsActive,
            }"
          >
            <span>
              <i class="step">{{ getStepAsNumber("jewellery/model") }}.</i>
              {{ $t("Menu.var.jewellery.basicModel") }}
            </span>
          </div>
          <div
            v-if="menuList['jewellery/setting']"
            @click="configure('jewellery/setting')"
            :class="{
              on: currentVarType === 'jewellery/setting' && !itemDetailsActive,
            }"
          >
            <span>
              <i class="step">{{ getStepAsNumber("jewellery/setting") }}.</i>
              {{ $t("Menu.var.jewellery.setting") }}</span
            >
          </div>
          <div
            v-if="
              menuList.stones &&
              !menuList['stones/jewellery/normal'] &&
              !menuList['stones/jewellery/model']
            "
            @click="configure('stones')"
            :class="{ on: currentVarType === 'stones' && !itemDetailsActive }"
          >
            <span>
              <i class="step">{{ getStepAsNumber("stones") }}.</i>
              {{ $t("Set.Item.Description.stones.title") }}
            </span>
          </div>
          <div
            v-if="menuList['stones/jewellery/normal']"
            @click="configure('stones/jewellery/normal')"
            :class="{
              on:
                currentVarType === 'stones/jewellery/normal' &&
                !itemDetailsActive,
            }"
          >
            <span>
              <i class="step"
                >{{ getStepAsNumber("stones/jewellery/normal") }}.</i
              >
              {{ $t("Set.Item.Description.stones.title") }}
            </span>
          </div>
          <div
            v-if="menuList['stones/jewellery/model']"
            @click="configure('stones/jewellery/model')"
            :class="{
              on:
                currentVarType === 'stones/jewellery/model' &&
                !itemDetailsActive,
            }"
          >
            <span>
              <i class="step"
                >{{ getStepAsNumber("stones/jewellery/model") }}.</i
              >
              {{ $t("Set.Item.Description.stones.model") }}
            </span>
          </div>
          <template
            v-if="
              !menuList['stones/jewellery/normal'] &&
              !menuList['stones/jewellery/model']
            "
          >
            <div
              v-for="(stoneGroup, stoneGroupId) in stoneList"
              :key="stoneGroupId"
              :class="{
                on: currentVarType === stoneGroupId && !itemDetailsActive,
              }"
              @click="configure(stoneGroupId)"
            >
              <span>
                <i class="step">{{ getStepAsNumber("stones") }}.</i>
                {{ stoneGroup }}
              </span>
            </div>
          </template>
          <div
            v-if="menuList['stones/diamondExchange']"
            @click="configure('stones/diamondExchange')"
            :class="{
              on:
                currentVarType === 'stones/diamondExchange' &&
                !itemDetailsActive,
            }"
          >
            <span>
              <i class="step"
                >{{ getStepAsNumber("stones/diamondExchange") }}.</i
              >
              {{ $t("Menu.var.diamondExchange") }}
            </span>
          </div>
          <div
            v-if="menuList.engraving"
            @click="configure('engraving')"
            :class="{
              on: currentVarType === 'engraving' && !itemDetailsActive,
            }"
          >
            <span>
              <i class="step">{{ getStepAsNumber("engraving") }}.</i>
              {{ $t("Set.Item.Description.engraving.title") }}
            </span>
          </div>
        </template>
        <template v-else>
          <div
            v-if="menuList.profiles"
            @click="configure('profiles')"
            :class="{ on: currentVarType === 'profiles' && !itemDetailsActive }"
          >
            <span>
              <i class="step">{{ getStepAsNumber("profiles") }}.</i>
              {{ $t("Set.Item.Description.profile") }}
            </span>
          </div>
          <div
            v-if="menuList.widths"
            @click="configure('widths')"
            :class="{ on: currentVarType === 'widths' && !itemDetailsActive }"
          >
            <span>
              <i class="step">{{ getStepAsNumber("widths") }}.</i>
              {{ $t("Set.Item.Description.width") }} /
              {{ $t("Set.Item.Description.height") }}
            </span>
          </div>
          <div
            v-if="menuList['jewellery/necklace']"
            @click="configure('jewellery/necklace')"
            :class="{
              on: currentVarType === 'jewellery/necklace' && !itemDetailsActive,
            }"
          >
            <span>
              <i class="step">{{ getStepAsNumber("jewellery/necklace") }}.</i>
              {{ $t("Menu.var.jewellery.necklace") }}</span
            >
          </div>
          <div
            v-if="menuList.lengths"
            @click="configure('lengths')"
            :class="{ on: currentVarType === 'lengths' && !itemDetailsActive }"
          >
            <span>
              <i class="step">{{ getStepAsNumber("lengths") }}.</i>
              {{ $t("Set.Item.Description.length") }}
            </span>
          </div>
          <div
            v-if="menuList.chainWidths"
            @click="configure('chainWidths')"
            :class="{
              on: currentVarType === 'chainWidths' && !itemDetailsActive,
            }"
          >
            <span>
              <i class="step">{{ getStepAsNumber("chainWidths") }}.</i>
              {{ $t("Set.Item.Description.width") }}
            </span>
          </div>
          <div
            v-if="menuList.allocations"
            @click="configure('allocations')"
            :class="{
              on: currentVarType === 'allocations' && !itemDetailsActive,
            }"
          >
            <span>
              <i class="step">{{ getStepAsNumber("allocations") }}.</i>
              {{ $t("Set.Item.Description.allocations") }}
            </span>
          </div>
          <div
            v-if="menuList.colors"
            @click="configure('colors')"
            :class="{ on: currentVarType === 'colors' && !itemDetailsActive }"
          >
            <span>
              <i class="step">{{ getStepAsNumber("colors") }}.</i>
              {{ $t("Set.Item.Description.color") }}</span
            >
          </div>
          <div
            v-if="menuList.metals"
            @click="configure('metals')"
            :class="{ on: currentVarType === 'metals' && !itemDetailsActive }"
          >
            <span>
              <i class="step">{{ getStepAsNumber("metals") }}.</i>
              {{ $t("Set.Item.Description.alloy") }}
            </span>
          </div>
          <div
            v-if="menuList.shutters"
            @click="configure('shutters')"
            :class="{ on: currentVarType === 'shutters' && !itemDetailsActive }"
          >
            <span>
              <i class="step">{{ getStepAsNumber("shutters") }}.</i>
              {{ $t("Set.Item.Description.shutter") }}
            </span>
          </div>
          <div
            v-if="menuList.finishes"
            @click="configure('finishes')"
            :class="{ on: currentVarType === 'finishes' && !itemDetailsActive }"
          >
            <span>
              <i class="step">{{ getStepAsNumber("finishes") }}.</i>
              {{ $t("Set.Item.Description.finish") }}
            </span>
          </div>
          <div
            v-if="menuList.grooves"
            @click="configure('grooves')"
            :class="{ on: currentVarType === 'grooves' && !itemDetailsActive }"
          >
            <span>
              <i class="step">{{ getStepAsNumber("grooves") }}.</i>
              {{ $t("Set.Item.Description.grooves.title") }}</span
            >
          </div>
          <div
            v-if="menuList.addons"
            @click="configure('addons')"
            :class="{ on: currentVarType === 'addons' && !itemDetailsActive }"
          >
            <span>
              <i class="step">{{ getStepAsNumber("addons") }}.</i>
              {{ $t("Set.Item.Description.addons.title") }}
            </span>
          </div>
          <div
            v-if="menuList.basicModel"
            @click="configure('basicModel')"
            :class="{
              on: currentVarType === 'basicModel' && !itemDetailsActive,
            }"
          >
            <span>
              <i class="step">{{ getStepAsNumber("basicModel") }}.</i>
              {{ $t("Menu.var.basicModel") }}
            </span>
          </div>
          <div
            v-if="
              menuList.stones &&
              !menuList['stones/jewellery/normal'] &&
              !menuList['stones/jewellery/model']
            "
            @click="configure('stones')"
            :class="{
              on: currentVarType === 'jewellery/stones' && !itemDetailsActive,
            }"
          >
            <span>
              <i class="step">{{ getStepAsNumber("stones") }}.</i>
              {{ $t("Set.Item.Description.stones.title") }}
            </span>
          </div>
          <div
            v-if="menuList['jewellery/model']"
            @click="configure('jewellery/model')"
            :class="{
              on: currentVarType === 'jewellery/model' && !itemDetailsActive,
            }"
          >
            <span>
              <i class="step">{{ getStepAsNumber("jewellery/model") }}.</i>
              {{ $t("Menu.var.jewellery.basicModel") }}
            </span>
          </div>
          <div
            v-if="menuList['jewellery/setting']"
            @click="configure('jewellery/setting')"
            :class="{
              on: currentVarType === 'jewellery/setting' && !itemDetailsActive,
            }"
          >
            <span>
              <i class="step">{{ getStepAsNumber("jewellery/setting") }}.</i>
              {{ $t("Menu.var.jewellery.setting") }}
            </span>
          </div>
          <div
            v-if="menuList['stones/jewellery/normal']"
            @click="configure('stones/jewellery/normal')"
            :class="{
              on:
                currentVarType === 'stones/jewellery/normal' &&
                !itemDetailsActive,
            }"
          >
            <span>
              <i class="step"
                >{{ getStepAsNumber("stones/jewellery/normal") }}.</i
              >
              {{ $t("Set.Item.Description.stones.title") }}
            </span>
          </div>
          <div
            v-if="menuList['stones/jewellery/model']"
            @click="configure('stones/jewellery/model')"
            :class="{
              on:
                currentVarType === 'stones/jewellery/model' &&
                !itemDetailsActive,
            }"
          >
            <span>
              <i class="step"
                >{{ getStepAsNumber("stones/jewellery/model") }}.</i
              >
              {{ $t("Set.Item.Description.stones.model") }}
            </span>
          </div>
          <template
            v-if="
              menuList['stones'] &&
              !menuList['stones/jewellery/normal'] &&
              !menuList['stones/jewellery/model']
            "
          >
            <div
              v-for="(stoneGroup, stoneGroupId) in stoneList"
              :key="stoneGroupId"
              :class="{
                on: currentVarType === stoneGroupId && !itemDetailsActive,
              }"
              :title="getTitle(stoneGroupId)"
              @click="configure(stoneGroupId)"
            >
              <span>
                <i class="step">{{ getStepAsNumber("stones") }}.</i>
                {{ stoneGroup }}
              </span>
            </div>
          </template>
          <div
            v-if="menuList.engraving"
            @click="configure('engraving')"
            :class="{
              on: currentVarType === 'engraving' && !itemDetailsActive,
            }"
          >
            <span>
              <i class="step">{{ getStepAsNumber("engraving") }}.</i>
              {{ $t("Set.Item.Description.engraving.title") }}
            </span>
          </div>
          <div
            v-if="menuList['stones/diamondExchange']"
            @click="configure('stones/diamondExchange')"
            :class="{
              on:
                currentVarType === 'stones/diamondExchange' &&
                !itemDetailsActive,
            }"
          >
            <span>
              <i class="step"
                >{{ getStepAsNumber("stones/diamondExchange") }}.</i
              >
              {{ $t("Menu.var.diamondExchange") }}
            </span>
          </div>
        </template>
        <div
          v-if="isRingsize"
          id="BtnNameAndSize"
          @click="configure('name')"
          :class="{
            on: showNameAndSize === true && itemDetailsActive !== true,
          }"
        >
          <span
            ><i class="step">{{ lastStep }}.</i
            >{{ $t("Set.Item.Description.name.title") }} /
            {{ $t("Set.Item.Description.ringsize") }}</span
          >
        </div>
        <div
          v-if="
            website === '123gold' &&
            shopId > 10000 &&
            $parent.getSetIds().length > 0
          "
          id="BtnWarehouse"
          @click="configure('warehouse')"
          :class="{ on: showWarehouse === true && itemDetailsActive !== true }"
        >
          <span>
            <i
              class="step"
              v-if="parseInt(lastStep) + (isRingsize ? 1 : 0) >= 10"
              >{{ parseInt(lastStep) + (isRingsize ? 1 : 0) }}.</i
            >
            <i class="step" v-else
              >{{ parseInt(lastStep) + (isRingsize ? 1 : 0) }}.</i
            >{{ $t("Menu.warehouse") }}
          </span>
        </div>
        <div @click="showSummary" :class="{ on: itemDetailsActive === true }">
          <!--<i class="step">{{ lastStep }}.</i>-->
          <span>{{ $t("Common.itemDetailsShow") }}</span>
        </div>
        <span id="share" @click="share" v-if="isShareAvailable()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
          >
            <path
              d="M4.66675 14V23.3333C4.66675 23.9522 4.91258 24.5456 5.35017 24.9832C5.78775 25.4208 6.38124 25.6666 7.00008 25.6666H21.0001C21.6189 25.6666 22.2124 25.4208 22.65 24.9832C23.0876 24.5456 23.3334 23.9522 23.3334 23.3333V14M18.6667 6.99998L14.0001 2.33331M14.0001 2.33331L9.33341 6.99998M14.0001 2.33331V17.5"
              stroke="#1E1E1E"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </span>
      </div>
    </nav>
    <button
      v-show="showRightArrow"
      class="icon-nav-arrow"
      type="button"
      aria-label="Scroll right"
      @click="scrollNavigation('right')"
    >
      &gt;
    </button>
  </div>
</template>

<script>
import Config from "@/vuex/Config";
import MenuList from "@/assets/Helper/MenuList";
import SetData from "@/vuex/SetData";
import Slider from "@/assets/Helper/Slider";

export default {
  name: "IconNavigation",
  data() {
    return {
      shopId: Config.getters.getActiveShop,
      website: Config.getters.getWebsite,
      appUrl: Config.getters.getAppUrl,
      config: Config.getters.getConfig,
      label: false,
      itemDetailsActive: false,
      showOverview: false,
      showNameAndSize: false,
      showWarehouse: false,
      showLeftArrow: false,
      showRightArrow: false,
    };
  },
  mounted() {
    this.$root.$on("setItemDetailsBtn", () => {
      this.itemDetailsActive = true;
    });
    this.$root.$on("unsetItemDetailsBtn", () => {
      this.itemDetailsActive = false;
    });
    this.$root.$on("setOverview", () => {
      this.itemDetailsActive = false;
      this.showOverview = true;
      this.showNameAndSize = false;
      this.showWarehouse = false;
      this.$parent.currentNavigation = "overview";
    });
    this.$root.$on("unsetOverview", () => {
      this.showOverview = false;
      this.showNameAndSize = false;
      this.showWarehouse = false;
      this.$parent.currentNavigation = "";
    });
    this.$root.$on("setNameAndSize", () => {
      this.showNameAndSize = true;
      this.showOverview = false;
      this.showWarehouse = false;
      this.$parent.currentNavigation = "name";
    });
    this.$root.$on("unsetNameAndSize", () => {
      this.showNameAndSize = false;
      this.showOverview = false;
      this.showWarehouse = false;
      this.$parent.currentNavigation = "";
    });

    const slider = this.$refs.navigationSlider;
    Slider.setSlider(slider);

    slider.addEventListener("scroll", this.updateScrollArrows, {
      passive: true,
    });
    window.addEventListener("resize", this.updateScrollArrows);
    this.$nextTick(() => {
      this.updateScrollArrows();
    });
  },
  updated() {
    this.$nextTick(() => {
      this.updateScrollArrows();
    });
  },
  beforeDestroy() {
    this.$root.$off("setItemDetailsBtn");
    this.$root.$off("unsetItemDetailsBtn");
    this.$root.$off("setOverview");
    this.$root.$off("unsetOverview");
    this.$root.$off("setNameAndSize");
    this.$root.$off("unsetNameAndSize");

    const slider = this.$refs.navigationSlider;
    if (slider) {
      slider.removeEventListener("scroll", this.updateScrollArrows);
    }
    window.removeEventListener("resize", this.updateScrollArrows);
  },
  props: ["set"],
  methods: {
    scrollNavigation: function (direction) {
      const slider = this.$refs.navigationSlider;
      if (!slider) {
        return;
      }

      const offset = Math.max(slider.clientWidth * 0.6, 200);
      slider.scrollBy({
        left: direction === "left" ? -offset : offset,
        behavior: "smooth",
      });
    },
    updateScrollArrows: function () {
      const slider = this.$refs.navigationSlider;
      if (!slider) {
        return;
      }

      const maxScrollLeft = slider.scrollWidth - slider.clientWidth;
      const canScroll = maxScrollLeft > 0;

      this.showLeftArrow = canScroll && slider.scrollLeft > 2;
      this.showRightArrow = canScroll && slider.scrollLeft < maxScrollLeft - 2;
    },
    showSummary: function () {
      this.$root.$emit("showItemDetails");
      this.$root.$emit("showItemDetails");
      this.itemDetailsActive = true;
      this.showOverview = false;
    },
    isShareAvailable: function () {
      return (
        navigator.share &&
        navigator.canShare &&
        navigator.canShare({
          title: document.title,
          url: window.location.href,
        })
      );
    },
    share: async function () {
      try {
        await navigator.share({
          title: document.title,
          url: window.location.href.replace(
            /^(https?:\/\/)\d+-[^.]+\./,
            "$1www."
          ),
        });
      } catch (err) {
        console.log(err);
      }
    },
    configure: function (type) {
      this.$root.$emit("hideItemDetails");

      this.itemDetailsActive = false;
      this.$parent.currentNavigation = type;

      this.showNameAndSize = false;
      this.showOverview = false;
      this.showWarehouse = false;

      if (
        type === "name" ||
        type === "ringsize" ||
        type === "overview" ||
        type === "warehouse"
      ) {
        if (type === "name" || type === "ringsize") {
          this.showNameAndSize = true;
          this.showOverview = false;
          this.showWarehouse = false;
        } else if (type === "warehouse") {
          this.showWarehouse = true;
          this.showNameAndSize = false;
          this.showOverview = false;
        } else {
          this.showNameAndSize = false;
          this.showOverview = true;
          this.showWarehouse = false;
        }
        Config.dispatch(
          "setVisualMode",
          type !== "warehouse" ? "show" : "warehouse"
        ).then(() => {
          Config.dispatch("setCurrentVarType", "").then(() =>
            this.$root.$emit("hideLoader3D")
          );
        });
      } else {
        Config.dispatch("setVisualMode", "show").then(() => {
          Config.dispatch("setCurrentVarType", type).then(() =>
            this.$root.$emit("hideLoader3D")
          );
        });
      }
    },
    getStonePositionText: function (group) {
      return this.$parent.getStonePositionText(group);
    },
    getTitle: function (groupAsRoute) {
      let title = "";
      let groupParts = groupAsRoute.split("/");
      if (groupParts.length > 1) {
        const groupId = groupParts[groupParts.length - 2];
        const item = this.set.items[this.set.currentItem]
          ? this.set.items[this.set.currentItem]
          : this.set.items[0];

        if (
          typeof item.description == "object" &&
          typeof item.description.stones == "object"
        ) {
          let groupData = item.description.stones.groups[groupId];
          title =
            groupData.numberInt +
            "x " +
            groupData.setting +
            " - " +
            groupData.quality.short +
            " - " +
            groupData.quality.long;
        }
      }
      return title;
    },
    getStepAsNumber: function (menuPoint) {
      let step = "";
      if (typeof this.menuList === "object") {
        step = Object.keys(this.menuList).indexOf(menuPoint) + 1;
        // if (step < 10) {
        //   step = "0" + step;
        // }
      }
      return step;
    },
  },
  computed: {
    isRingsize: function () {
      let isRingsize = false;
      if (
        this.set.items[this.set.currentItem] !== undefined &&
        this.set.items[this.set.currentItem].description &&
        this.set.items[this.set.currentItem].description.possibleVariations
      ) {
        isRingsize =
          this.set.items[this.set.currentItem].description.possibleVariations
            .ringsize;
      }
      return isRingsize;
    },
    lastStep: function () {
      let step = "";
      if (typeof this.menuList === "object") {
        step = Object.keys(this.menuList).length + 1;
        // if (step < 10) {
        //  step = "0" + step;
        // }
      }
      return step;
    },
    getItemType: function () {
      if (
        this.set.currentItem === "overview" ||
        this.set.currentItem === "all" ||
        this.set.currentItem === "set"
      ) {
        return "default";
      } else if (this.set.items[this.set.currentItem] !== undefined) {
        return this.set.items[this.set.currentItem].description.jewelleryType ==
          3
          ? "engagement"
          : "default";
      } else {
        return "default";
      }
    },
    menuList: function () {
      return MenuList.get(this.set.currentItem);
    },
    stoneList: function () {
      let possibleVariationsSet =
        SetData.getters.getSet.summary.possibleVariations;
      let list = {};

      if (
        (this.set.currentItem !== "overview" &&
          this.set.currentItem !== "all" &&
          this.set.currentItem !== "set") ||
        possibleVariationsSet.stones
      ) {
        const item = this.set.items[this.set.currentItem]
          ? this.set.items[this.set.currentItem]
          : this.set.items[0];

        if (item) {
          if (
            typeof item.description == "object" &&
            typeof item.description.stones == "object"
          ) {
            for (let groupId in item.description.stones.groups) {
              let index = "stones/group/" + groupId + "/0";
              if (item.description.stones.groups[groupId].side !== "top") {
                list[index] =
                  this.$t("Menu.var.stoneGroupShort") +
                  " " +
                  this.getStonePositionText(
                    item.description.stones.groups[groupId]
                  );
              } else {
                list[index] =
                  this.$t("Menu.var.stoneGroupShort") +
                  " " +
                  item.description.stones.groups[groupId].size.toFixed(3) +
                  " ct.";
              }
            }
          }
        }
      }
      return list;
    },
    currentVarType: function () {
      let possibleVariationsSet =
        SetData.getters.getSet.summary.possibleVariations;

      let currentVarType = Config.getters.getcurrentVarType;
      let currentItemId = SetData.getters.getCurrentItemId;

      if (currentVarType.indexOf("stones/group/") > -1) {
        if (isNaN(currentItemId) && !possibleVariationsSet.stones) {
          currentVarType = "jewellery/stones";
        } else {
          let currentVarTypeParts = currentVarType.split("/");
          let lastItemKey = currentVarTypeParts.length - 1;

          if (currentVarTypeParts[lastItemKey]) {
            let stoneId = currentVarTypeParts[lastItemKey];
            if (!isNaN(stoneId) && stoneId > 0) {
              currentVarTypeParts[lastItemKey] = 0;
              currentVarType = currentVarTypeParts.join("/");
            }
          }
        }
      }

      return currentVarType;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
#app {
  .icon-nav-container {
    display: none;
    align-items: stretch;
    width: 100%;
    background-color: #ffffff;

    .icon-nav-arrow {
      min-width: 5rem;
      border: none;
      background-color: #ffffff;
      color: #000000;
      font-size: 2rem;
      cursor: pointer;
      line-height: 1;
      padding: 0;

      &:hover {
        background-color: $darkGrey;
      }
    }
  }

  .icon-nav {
    background-color: #ffffff;
    text-align: center;
    border-bottom: none;
    //width: max-content;
    overflow-x: auto;
    flex: 1;
    padding-top: 0;
    display: none;

    #share {
      cursor: pointer;
      display: flex;
      padding-right: 2.5rem;
      margin: 0 0 0.5rem 2rem;
      align-items: center;
    }

    .dot {
      margin-right: 1.5rem;
      height: 1rem;
      width: 1rem;
      border: 1px solid #333;
      border-radius: 50%;
      display: inline-block;
    }

    .step {
      font-style: normal;
      padding-right: 0.5rem;
    }

    .label {
      display: flex;
      width: max-content;
      background-color: #ffffff;
      color: #000000;

      div {
        left: 0;
        //min-width: 17rem;
        width: max-content;
        padding: 0 2.5rem 0 1rem;
        line-height: 6rem;
        cursor: pointer;
        text-align: center;
        height: max-content;

        span {
          font-size: 1.6rem;
          letter-spacing: 0.1rem;
          text-align: center;
          font-weight: normal;
          padding-left: 1.5rem;
          width: max-content;
        }

        .step,
        .dot {
          //display: none;
        }
      }

      div:hover,
      div.on {
        background-color: $darkGrey;
      }

      div.on {
        span {
          font-weight: bold;
        }
      }

      .close {
        margin-top: 4rem;

        span {
          text-align: center;
        }

        &:hover {
          border-bottom: none;
        }

        span {
          line-height: 4rem;
        }
      }
    }

    @media (min-width: 1200px) {
      display: block;
    }
  }

  .icon-nav-container {
    @media (min-width: 1200px) {
      display: flex;
    }
  }

  .icon-nav {
    @media (min-width: 1200px) {
      display: block;
    }
  }
}
</style>
